
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/page/[pageNum]",
      function () {
        return require("private-next-pages/education/page/[pageNum].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/page/[pageNum]"])
      });
    }
  